import React from "react";
import { Box, Button, Flex, FormControl, FormLabel, Icon, Input, Text } from "@chakra-ui/react";
import { FaFileExport, FaPlay } from "react-icons/fa";
import ExtractsList from "./components/extractsList";
// import FinantialList from "./components/financialList";
import { useRecoilState } from "recoil";
import { customColors } from "../../../atoms/customColors";

export default function ExtractsDetails(){
    const colors = useRecoilState(customColors)[0];

    return (
        <Flex direction={"column"} alignItems={"center"} bgColor={"#255255255"} h="100%">
            <Box mb={"50px"} width={"100%"} height={"fit-content"} mt={"0.3%"} mx="auto" py={3} px={3}>
                <Flex px={8} py={3} alignItems="center">
                    <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px"/>
                    <Text mx={4} color={colors.BLUEMONEDDBUTTONS} fontSize={35} fontWeight={"bold"}>Extrato Detalhado</Text>
                </Flex>
            </Box>
            <Box px={10} width={"100%"} height={"fit-content"} alignItems={"center"} >
                <Flex alignItems="center" my="10px">
                    <FormLabel color={"#7D7D7D"}>Buscar pelo ID da transação ou ID de referência</FormLabel>
                    <Input type="text" w={"300px"} borderRadius={"20px"} bgColor={"white"}/>
                    <Button
                        bg={"none"}
                        color={colors.BLUEMONEDDBUTTONS}
                        isDisabled={true}
                        onClick={() => {
                            // goToDashboard(navigate);
                        }}
                        fontSize="20px"
                    >
                        <Icon mr={2} as={FaFileExport}/>
                        Exporte o Seu Extrato
                    </Button>
                </Flex>
                <Flex w={"80%"} alignItems="center" my="10px" justifyContent={"space-between"}>
                    <FormLabel color={"#7D7D7D"}>Buscar pela data</FormLabel>
                    <Input type="date" w={"200px"} borderRadius={"20px"} bgColor={"white"}/>
                    <FormLabel color={"#7D7D7D"}>Buscar pelo valor</FormLabel>
                    <Input type="text" w={"100px"} borderRadius={"20px"} bgColor={"white"}/>
                    <FormLabel color={"#7D7D7D"}>Buscar pela venda</FormLabel>
                    <Input type="text" w={"100px"} borderRadius={"20px"} bgColor={"white"}/>
                </Flex>
            </Box>
            <ExtractsList/>
        </Flex>
    )
};